/// A language in the reader's own language, falling back to the code where the browser has no
/// name for it. Intl is the browser's own table, so this needs none of its own.
///
/// The locale is the one the interface is set to rather than the browser's own: somebody who
/// chose German here wants "Deutsch" whatever language their computer was installed in.
export function languageName(code: string, locale?: string): string {
  try {
    return new Intl.DisplayNames(locale, { type: 'language' }).of(code) ?? code.toUpperCase();
  } catch {
    return code.toUpperCase();
  }
}
